import { render, staticRenderFns } from "./TreeViewComponent.vue?vue&type=template&id=126056d6&"
import script from "./TreeViewComponent.vue?vue&type=script&lang=js&"
export * from "./TreeViewComponent.vue?vue&type=script&lang=js&"
import style0 from "./TreeViewComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports